<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">{{ title }}</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" class="closed-exception-form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <mat-form-field class="date-range-form-field">
        <mat-label>Date Range</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate placeholder="Start date" formControlName="startDate" [name]="'startDate'" required />
          <input matEndDate placeholder="End date" formControlName="endDate" [name]="'endDate'" required />
        </mat-date-range-input>
        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
        @if (form.controls.startDate.hasError('matStartDateInvalid')) {
          <mat-error>Invalid start date</mat-error>
        }
        @if (form.controls.endDate.hasError('matEndDateInvalid')) {
          <mat-error>Invalid end date</mat-error>
        }
        @if (form.get('startDate')?.hasError('required')) {
          <mat-error> Start Date is Required. </mat-error>
        }
        @if (form.get('endDate')?.hasError('required')) {
          <mat-error> End Date is Required. </mat-error>
        }
      </mat-form-field>
      <mat-slide-toggle
        class="specific-time-toggle"
        color="primary"
        (change)="onTimeToggleClick($event)"
        [checked]="timeToggleChecked"
        >Specific Time</mat-slide-toggle
        >
        <div class="detail-right-column start-end-time-section">
          @if (isSafari()) {
            <div class="segmented-timepicker-wrapper flex-half">
              <ndt-segmented-timepicker
                [required]="timeToggleChecked"
                label="Start Time"
                formControlName="startTime"
              ></ndt-segmented-timepicker>
              @if (form.get('startTime')?.touched && form.get('startTime')?.invalid) {
                <div
                  class="segmented-timepicker-error"
                  >
                  @if (form.get('startTime')?.hasError('required')) {
                    <span>Start Time is required.</span>
                  }
                  @if (form.get('startTime')?.hasError('invalidTimeRange')) {
                    <span
                      >Start Time should be before End Time.</span
                      >
                    }
                  </div>
                }
              </div>
              <div class="segmented-timepicker-wrapper flex-half">
                <ndt-segmented-timepicker
                  [required]="timeToggleChecked"
                  label="End Time"
                  formControlName="endTime"
                ></ndt-segmented-timepicker>
                @if (form.get('endTime')?.touched && form.get('endTime')?.invalid) {
                  <div
                    class="segmented-timepicker-error"
                    >
                    @if (form.get('endTime')?.hasError('required')) {
                      <span>End Time is required.</span>
                    }
                    @if (form.get('endTime')?.hasError('invalidTimeRange')) {
                      <span
                        >End Time should be after Start Time.</span
                        >
                      }
                    </div>
                  }
                </div>
              } @else {
                <mat-form-field class="flex-half field-padding-right">
                  <mat-label>Start Time</mat-label>
                  <input
                    matInput
                    type="time"
                    autocomplete="off"
                    formControlName="startTime"
                    [name]="'startTime'"
                    [required]="timeToggleChecked"
                    />
                    @if (form.get('startTime')?.hasError('required')) {
                      <mat-error> Start Time is Required. </mat-error>
                    }
                    @if (form.get('startTime')?.hasError('invalidTimeRange')) {
                      <mat-error
                        >Start Time should be before End Time.</mat-error
                        >
                    }
                  </mat-form-field>
                  <mat-form-field class="flex-half">
                    <mat-label>End Time</mat-label>
                    <input
                      matInput
                      type="time"
                      autocomplete="off"
                      formControlName="endTime"
                      [name]="'endTime'"
                      [required]="timeToggleChecked"
                      />
                      @if (form.get('endTime')?.hasError('required')) {
                        <mat-error> End Time is Required. </mat-error>
                      }
                      @if (form.get('endTime')?.hasError('invalidTimeRange')) {
                        <mat-error
                          >End Time should be after Start Time.</mat-error
                          >
                      }
                    </mat-form-field>
                  }
                </div>
                <div class="flex-container flex-half">
                  <mat-form-field class="flex-half-drop with-half-button">
                    <mat-label>Prompt</mat-label>
                    <input
                      [lcsSingleSelect]="promptSelect"
                      [accountId]="accountId"
                      [promptTypesToInclude]="[4]"
                      ndtPromptSelect
                      type="text"
                      formControlName="prompt"
                      [name]="'prompt'"
                      />
                      <ndt-prompt-select #promptSelect [isIncludeEmptyOption]="true"></ndt-prompt-select>
                      @if (form.get('prompt')?.hasError('required')) {
                        <mat-error> Prompt is Required. </mat-error>
                      }
                    </mat-form-field>
                    <div class="flex-half-button">
                      <button
                        mat-mini-fab
                        color="primary"
                        type="button"
                        (click)="onAddPromptClick($event)"
                        class="prompt-button"
                        >
                        <mat-icon>add</mat-icon>
                      </button>
                    </div>
                  </div>
                  @if (title === 'Add Closed Exception') {
                    <mat-checkbox
                      class="flex-full copy-schedules"
                      id="useSchedulesToggle"
                      color="primary"
                      (change)="onCopyToSchedulesClick($event)"
                      [checked]="showSchedulesMultiSelect"
                      >Copy to additional schedules
                    </mat-checkbox>
                  }
                  @if (showSchedulesMultiSelect) {
                    <ndt-schedule-advanced-multi-select
                      [accountIdFilter]="accountId"
                      [scheduleIdsToExclude]="scheduleId"
                      [itemsControl]="form.controls.schedulesToCopyTo"
                      (change)="emitScheduleChange()"
                    ></ndt-schedule-advanced-multi-select>
                  }
                </mat-dialog-content>
                <mat-dialog-actions>
                  <button type="submit" title="Create" mat-raised-button>Save</button>
                </mat-dialog-actions>
              </form>
            </lcs-loading-overlay>
